/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeliveryPattern
 */
export interface DeliveryPattern {
    /**
     * 
     */
    frequency_units_code?: string;
    /**
     * 
     */
    period?: number;
    /**
     * 
     */
    period_units_code?: number;
    /**
     * 
     */
    period_units_code_definition?: string;
    /**
     * 
     */
    quantity?: string;
    /**
     * 
     */
    quantity_units_code?: string;
    /**
     * 
     */
    quantity_units_code_definition?: string;
    /**
     * 
     */
    delivery_pattern_qualifier_code?: string;
    /**
     * 
     */
    delivery_pattern_qualifier_definition?: string;
    /**
     * 
     */
    delivery_pattern_time_qualifier_code?: string;
    /**
     * 
     */
    delivery_pattern_time_qualifier_definition?: string;
    /**
     * 
     */
    time_period_qualifier_code?: string;
    /**
     * 
     */
    time_period_qualifier_definition?: string;
    /**
     * 
     */
    measurement_units_code?: string;
    /**
     * 
     */
    measurement_units_code_definition?: string;
    /**
     * 
     */
    number_of_periods?: number;
    /**
     * 
     */
    sample_selection_modulus?: number;
}

/**
 * Check if a given object implements the DeliveryPattern interface.
 */
export function instanceOfDeliveryPattern(value: object): value is DeliveryPattern {
    return true;
}

export function DeliveryPatternFromJSON(json: any): DeliveryPattern {
    return DeliveryPatternFromJSONTyped(json, false);
}

export function DeliveryPatternFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeliveryPattern {
    if (json == null) {
        return json;
    }
    return {
        
        'frequency_units_code': json['frequency_units_code'] == null ? undefined : json['frequency_units_code'],
        'period': json['period'] == null ? undefined : json['period'],
        'period_units_code': json['period_units_code'] == null ? undefined : json['period_units_code'],
        'period_units_code_definition': json['period_units_code_definition'] == null ? undefined : json['period_units_code_definition'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
        'quantity_units_code': json['quantity_units_code'] == null ? undefined : json['quantity_units_code'],
        'quantity_units_code_definition': json['quantity_units_code_definition'] == null ? undefined : json['quantity_units_code_definition'],
        'delivery_pattern_qualifier_code': json['delivery_pattern_qualifier_code'] == null ? undefined : json['delivery_pattern_qualifier_code'],
        'delivery_pattern_qualifier_definition': json['delivery_pattern_qualifier_definition'] == null ? undefined : json['delivery_pattern_qualifier_definition'],
        'delivery_pattern_time_qualifier_code': json['delivery_pattern_time_qualifier_code'] == null ? undefined : json['delivery_pattern_time_qualifier_code'],
        'delivery_pattern_time_qualifier_definition': json['delivery_pattern_time_qualifier_definition'] == null ? undefined : json['delivery_pattern_time_qualifier_definition'],
        'time_period_qualifier_code': json['time_period_qualifier_code'] == null ? undefined : json['time_period_qualifier_code'],
        'time_period_qualifier_definition': json['time_period_qualifier_definition'] == null ? undefined : json['time_period_qualifier_definition'],
        'measurement_units_code': json['measurement_units_code'] == null ? undefined : json['measurement_units_code'],
        'measurement_units_code_definition': json['measurement_units_code_definition'] == null ? undefined : json['measurement_units_code_definition'],
        'number_of_periods': json['number_of_periods'] == null ? undefined : json['number_of_periods'],
        'sample_selection_modulus': json['sample_selection_modulus'] == null ? undefined : json['sample_selection_modulus'],
    };
}

export function DeliveryPatternToJSON(json: any): DeliveryPattern {
    return DeliveryPatternToJSONTyped(json, false);
}

export function DeliveryPatternToJSONTyped(value?: DeliveryPattern | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'frequency_units_code': value['frequency_units_code'],
        'period': value['period'],
        'period_units_code': value['period_units_code'],
        'period_units_code_definition': value['period_units_code_definition'],
        'quantity': value['quantity'],
        'quantity_units_code': value['quantity_units_code'],
        'quantity_units_code_definition': value['quantity_units_code_definition'],
        'delivery_pattern_qualifier_code': value['delivery_pattern_qualifier_code'],
        'delivery_pattern_qualifier_definition': value['delivery_pattern_qualifier_definition'],
        'delivery_pattern_time_qualifier_code': value['delivery_pattern_time_qualifier_code'],
        'delivery_pattern_time_qualifier_definition': value['delivery_pattern_time_qualifier_definition'],
        'time_period_qualifier_code': value['time_period_qualifier_code'],
        'time_period_qualifier_definition': value['time_period_qualifier_definition'],
        'measurement_units_code': value['measurement_units_code'],
        'measurement_units_code_definition': value['measurement_units_code_definition'],
        'number_of_periods': value['number_of_periods'],
        'sample_selection_modulus': value['sample_selection_modulus'],
    };
}

